export default "__VITE_ASSET__CUx0BRCa__"